import React, { Fragment } from 'react';
import { InputLabel, MenuItem, Select } from '@material-ui/core';
import { injectIntl } from "react-intl";
import useGlobalContext from '../hooks/useGlobalContext';
import messages from "./messages";

const ServiceDropdown = props => {
  const {
    hasTitle,
    intl: { formatMessage },
  } = props;
  const {
    state: { services },
  } = useGlobalContext();
  return (
    <Fragment>
      {services.length > 1 && hasTitle && <InputLabel>{formatMessage(messages.service)}</InputLabel>}
      {services.length > 1 && (
        <Select fullWidth variant="outlined" {...props}>
          {services.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      )}
    </Fragment>
  );
};

export default injectIntl(ServiceDropdown);
